function openDetailsByDefault() {
  const details = document.querySelectorAll('.mobile-facets__details');
  const forceOpen = window.getComputedStyle(details[0]).getPropertyValue("--details-force-closed");
  if (details.length) {
    if (window.innerWidth >= forceOpen) {
      details.forEach(detail => {
        detail.setAttribute('open', 'open');
      });
    } else {
      details.forEach(detail => {
        //detail.removeAttribute('open');
      });
    }
  }
}
openDetailsByDefault();
const filterMenu = document.querySelector('.mobile-facets__disclosure');
if (filterMenu) {
  filterMenu.addEventListener('click', openDetailsByDefault);
}
window.addEventListener('resize', openDetailsByDefault);

function overlayHeight() {
  const filterOverlayContainer = document.querySelector('.mobile-facets__disclosure .filter-overlay-container');
  const filterOverlay = document.querySelector('.mobile-facets__disclosure .filter-overlay');
  if (filterOverlayContainer && filterOverlay) {
    const height = document.body.scrollHeight - (filterOverlayContainer.getBoundingClientRect().top +  window.scrollY + 5);
    filterOverlay.style.height = height + 'px';
  }
}
if (filterMenu) {
  filterMenu.addEventListener('click', overlayHeight);
}
window.addEventListener('resize', overlayHeight);

priceBoundaries();
function priceBoundaries() {
  const list = document.querySelector('#custom-price-range');
  if (!list) return;

  const cardWrappers = document.querySelectorAll('.card-wrapper');
  const cardPrices = Array.from(cardWrappers).map(card => {
    const priceEl = card.querySelector('.price-item.price-item--regular');
    if (!priceEl) return null;
    const priceText = priceEl.textContent.replace(/[^0-9.,]/g, '').replace(',', '.');
    return parseFloat(priceText);
  });

  const validPrices = cardPrices.filter(price => !isNaN(price) && price !== null);
  if (!validPrices.length) return;

  const minPrice = Math.min(...validPrices);
  const maxPrice = Math.max(...validPrices);

  const step = 100;
  const boundaries = [];

  let start = Math.floor(minPrice / step) * step;
  for (let boundary = start; boundary <= maxPrice; boundary += step) {
    boundaries.push(boundary + '-' + (boundary + step));
  }
  
  boundaries.forEach(boundary => {
    list.innerHTML += 
      `<li class="mobile-facets__item list-menu__item">
        <label for="custom-price-${boundary}" class="facets__label mobile-facets__label">
          <input class="mobile-facets__checkbox" type="checkbox" value="${boundary}" id="custom-price-${boundary}">
          <span class="mobile-facets__box"></span>
          <span class="facet-checkbox__text" aria-hidden="true"><span class="facet-checkbox__text-label">${boundary}</span></span>
          <span class="visually-hidden">${boundary}</span>
        </label>
      </li>`;
  });

  const priceGte = document.querySelector('.filter-min-price');
  const priceLte = document.querySelector('.filter-max-price');
  const priceInputs = list.querySelectorAll('input');

  if (priceInputs.length && priceGte && priceLte) {
    priceInputs.forEach(input => {
      if (priceGte.value && priceLte.value) {
        const [minValue, maxValue] = input.value.split('-').map(Number);
        if (minValue >= parseInt(priceGte.value) && maxValue <= parseInt(priceLte.value)) {
          input.checked = true;
        }
      }

      input.addEventListener('change', () => {
        checkPrices();
      });
    });
  }

  function checkPrices() {
    let minSelected = null;
    let maxSelected = null;

    priceInputs.forEach(input => {
      if (input.checked) {
        const [minValue, maxValue] = input.value.split('-').map(Number);
        if (minSelected === null || minValue < minSelected) minSelected = minValue;
        if (maxSelected === null || maxValue > maxSelected) maxSelected = maxValue;
      }
    });

    setPrices(minSelected, maxSelected);
  }

  function setPrices(min, max) {
    if (priceGte && min !== null) priceGte.value = min;
    if (priceLte && max !== null) priceLte.value = max;
  }
}
